export default __webpack_public_path__ + "static/01e3d18560705a17f3de7d80f64c42cf.png";